import {h} from 'ui/Framework';

export default h('svg', {
  width: '30',
  height: '30',
  viewBox: '-1 -1 32 32',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', [
      h('g', [
        h('rect', {
          stroke: '#000',
          fill: 'none',
          width: '30',
          height: '30',
          rx: '5'
        }),
        h('g', {
          transform: 'translate(5 5)',
          stroke: '#000'
        }, [
          h('rect', {
            fill: 'none',
            y: '.769',
            width: '20',
            height: '18.974',
            rx: '2'
          }),
          h('path', {
            d: 'M.512 4.5h18.463',
            strokeLinecap: 'square'
          }),
          h('path', {
            d: 'M3.5 2.185V.133M15.5 2.185V.133',
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
          })
        ]),
        h('path', {
          d: 'M12.14 15.98h.31c.227 0 .44-.023.64-.07.2-.047.375-.122.525-.225.15-.103.268-.238.355-.405.087-.167.13-.367.13-.6 0-.2-.037-.382-.11-.545a1.24 1.24 0 0 0-.305-.42 1.397 1.397 0 0 0-.45-.27 1.52 1.52 0 0 0-.535-.095c-.3 0-.565.07-.795.21-.23.14-.415.347-.555.62l-.61-.32c.22-.38.5-.662.84-.845.34-.183.727-.275 1.16-.275.28 0 .545.042.795.125.25.083.47.205.66.365.19.16.34.358.45.595.11.237.165.508.165.815 0 .42-.117.772-.35 1.055a1.664 1.664 0 0 1-.88.565v.02a1.86 1.86 0 0 1 1.02.585c.273.303.41.695.41 1.175 0 .34-.062.642-.185.905a2.04 2.04 0 0 1-1.22 1.09 2.634 2.634 0 0 1-.875.145c-.52 0-.973-.125-1.36-.375-.387-.25-.68-.608-.88-1.075l.68-.25c.12.34.32.605.6.795.28.19.6.285.96.285.2 0 .395-.035.585-.105a1.466 1.466 0 0 0 .845-.775c.087-.187.13-.4.13-.64 0-.267-.052-.492-.155-.675a1.266 1.266 0 0 0-.415-.445 1.794 1.794 0 0 0-.59-.245 3.059 3.059 0 0 0-.68-.075h-.31v-.62zM19.38 20h-.72v-6.19l-1.28 1.09-.44-.5 1.8-1.48h.64V20z',
          fill: '#000'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-calendar-small.es6.js